import React from 'react';
import { Link } from 'react-router-dom';

const BlogCard = ({ id, heading, subHeading, cardImg, imgDesc, aboutTopic,dummyDesc }) => {
    return (
        <div className='p-5 shadow-sm rounded-md pb-4 sm:pb-8 pt4 sm:pt8 text-start border border-gray-100'>
            {/* <h4 className='text-xl md:text-2xl text-medium hover:text-primaryColor cursor-pointer'> {heading} </h4> */}
            {/* <p className="mt-2 sm:mt-4 md:mt-8 mb-2 text-gray-600">
            {subHeading}
        </p> */}
            <div>
                <img src={cardImg} alt="card Img" className='w-full h-60 rounded-md bg-cover' />
            </div>
            <h4 className='text-xl md:text-2xl text-medium font-medium mt-3 hover:text-primaryColor cursor-pointer'> {heading} </h4>
            {/* <p className="text-sm my-2 pl-4 ">
                Be the first of your friends to like this.
            </p> */}
            <p className="text-lg text-gray-700 mt-4 ">
                {/* {imgDesc} */}
                {dummyDesc}
            </p>
            {/* <p className="text-gray-400 text-base  my-1 sm:my-2">
                {aboutTopic}
            </p> */}

            <Link to={`/blog/cardDetail/${id}`} className='px-2.5 py-1 rounded-md text-white bg-primaryColor hover:bg-primaryColor hover:bg-orange-500 inline-block mt-2 sm:mt-4 text-lg'>Read More</Link>
        </div>
    )
}

export default BlogCard